<template>
  <div class="payment-success-container">
    <div class="success-card">
      <div class="logo-section">
        <img src="@/assets/images/logo/logo.png" alt="Logo" class="logo" />
      </div>

      <div class="success-icon">
        <feather-icon icon="CheckCircleIcon" size="64" class="text-success" />
      </div>

      <h1 class="success-title">{{ $t('Payment Successful!') }}</h1>

      <div class="success-message">
        <p>{{ $t('Your payment has been processed successfully.') }}</p>
      </div>

      <div class="action-buttons">
        <b-button variant="primary" size="lg" @click="goToPayments">
          <div class="d-flex align-items-center">
            <feather-icon icon="ListIcon" size="16" class="mr-2" />
            <span>{{ $t('View All Payments') }}</span>
          </div>
        </b-button>

        <b-button variant="outline-primary" size="lg" @click="goToDashboard">
          <div class="d-flex align-items-center">
            <feather-icon icon="HomeIcon" size="16" class="mr-2" />
            <span>{{ $t('Go to Dashboard') }}</span>
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  name: 'PaymentSuccess',
  components: {
    BButton
  },
  data() {
    return {
      orderId: this.$route.query.orderId || this.$route.params.orderId,
      amount: this.$route.query.amount || '0.00',
      currency: this.$route.query.currency || 'USD'
    };
  },
  methods: {
    goToPayments() {
      this.$router.push({ name: 'payments' });
    },

    goToDashboard() {
      this.$router.push({ name: 'dashboard' });
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style scoped lang="scss">
.payment-success-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem;
}

.success-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem;
    margin: 1rem;
  }
}

.logo-section {
  margin-bottom: 2rem;

  .logo {
    max-height: 60px;
    width: auto;
    object-fit: contain;
  }
}

.success-icon {
  margin-bottom: 2rem;

  .feather-icon {
    color: #28a745;
  }
}

.success-title {
  color: #2c3e50;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
}

.success-details {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;

  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  font-weight: 600;
  color: #6c757d;
}

.detail-value {
  font-weight: 500;
  color: #2c3e50;
}

.success-message {
  margin-bottom: 2rem;

  p {
    color: #6c757d;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;

    .btn {
      font-size: 12px;
      width: 100%;
    }
  }
}

.btn {
  border-radius: 10px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
}

.badge {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
}
</style>
